import React from 'react';
import Button from 'jbc-front/components/Button';
import { useMutation } from '../components/Graphql';
import { gql } from '@apollo/client';
import { Panel, Headding, Item, Lead, Description, Buttons } from '../components/PrimaryPanel';
import { BASIC_INFORMATION_FRAGMENT } from './BasicInfos';
import useReactRouter from 'use-react-router';
import { CustomDescription } from '../components/QuestionDescription';
import styles from './ResignInYear.scss';

const ANSWER_RESIGN_IN_YEAR = gql`
  mutation answerResignInYear($answer: Boolean!) {
    answerResignInYear(input: { resignBeforeYearEnd: $answer }) {
      questions {
        id
        status
      }
      request {
        id
        profile {
          id
          ...BasicInformation
          resignBeforeYearEnd
          needAdjThisYear
          nextYearOnly
        }
      }
    }
  }
  ${BASIC_INFORMATION_FRAGMENT}
`;

const Question = ({ dispatch }) => {
  const [anwser, { loading }] = useMutation(ANSWER_RESIGN_IN_YEAR, {
    refetchQueries: ['clientSettings']
  });
  const { history } = useReactRouter();
  return (
    <Panel>
      <Headding className={styles.primaryPanelHeader}>年内退職予定</Headding>
      <Item>
        <Lead>12月給与の支給前に退職する予定ですか？</Lead>
        <CustomDescription field="top" />
        <Buttons>
          <Button
            huge
            secondary
            disabled={loading}
            onClick={async () => {
              await anwser({ variables: { answer: true } });
              history.push('/employee_input');
            }}
          >
            退職予定です
          </Button>
          <Button
            huge
            secondary
            disabled={loading}
            onClick={async () => {
              await anwser({ variables: { answer: false } });
              history.push('/employee_input');
            }}
          >
            退職予定はありません
          </Button>
        </Buttons>
      </Item>
    </Panel>
  );
};

export default Question;
